import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';

// -----------------------------------------------------------
//  Designer
// -----------------------------------------------------------
var Designer = createReactClass({
  render() {
    return <p className="designers">
             <span>By: </span>
             <a href={ this.props.url + '?designer=' + encodeURIComponent(this.props.name.toLowerCase()) }>
               { this.props.name }
             </a>
           </p>;
  }
});

export default Designer;
